module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit member","clubsMembersActionsEditOneSuccess":"%{fullName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger medlem","clubsMembersActionsEditOneSuccess":"%{fullName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
